// extracted by mini-css-extract-plugin
module.exports = {"powerName":"ProductNoteFiche_powerName__uXiGd","cardPowerNote":"ProductNoteFiche_cardPowerNote__29axV","imgNote":"ProductNoteFiche_imgNote__3rStx"};